import { useIntl } from "react-intl";

const NumberOfSites = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.NumberOfSites.header",
            defaultMessage: "Number of sites"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.NumberOfSites.body",
            defaultMessage:
                "This is the number of sites (also called “instances”) you can license based on the subscription plan you choose. One site is typically enough for most small to medium organizations."
        }),
        body2: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.NumberOfSites.body2",
            defaultMessage:
                "Enterprise subscribers often opt for multiple sites, up to 150 per product, to:"
        }),
        listItems: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.NumberOfSites.listItems",
                defaultMessage:
                    "<li>Offer organizational autonomy to independent brands</li> <li>Improve security through separating data by region or department</li> <li>Customize instances based on Marketplace apps, project configurations, and more</li>"
            },
            {
                li: (chunk: React.ReactNode) => <li>{chunk}</li>
            }
        )
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.body2}</p>
            <ul>{messages.listItems}</ul>
        </>
    );
};

export default NumberOfSites;
